;(() => {
  const ROOT_SEL = '#nosto-serp';
  const hasFn = (name) => typeof window[name] === 'function';

  let mounted = false;

  function mountRoot() {
    if (mounted) return;

    const root = document.querySelector(ROOT_SEL);
    if (!root || !root.firstElementChild) return; // Nosto n’a encore rien injecté

    mounted = true;
    root.dataset.nostoMounted = '1';
    root.classList.add('nosto-mounted');
    document.body.classList.add('nosto-serp-mounted');

    // Init ProductCard
    if (window.ProductCard && typeof window.ProductCard.init === 'function') {
      try {
        window.ProductCard.init(root);
      } catch (err) {
        console.warn('[NOSTO_GLUE] ProductCard.init error', err);
      }
    }

    // Colonnage éventuel
    if (hasFn('applyColumnClasses')) {
      try {
        window.applyColumnClasses(root);
      } catch (err) {
        console.warn('[NOSTO_GLUE] applyColumnClasses error', err);
      }
    }
  }

  function watchRoot() {
    const root = document.querySelector(ROOT_SEL);
    if (!root || root.dataset.nostoGlueInited) return;
    root.dataset.nostoGlueInited = '1';

    const mo = new MutationObserver(() => {
      mountRoot();
      if (mounted) mo.disconnect();
    });

    // On écoute tout de suite, pas de setTimeout 300ms
    mo.observe(root, { childList: true, subtree: true });

    // Si Nosto avait déjà injecté
    mountRoot();
  }

  // Quand Nosto signale qu'il a rendu, on tente directement de monter
  window.addEventListener('nosto:rendered', () => {
    mountRoot();
  });

  // Boot DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRoot, { once: true });
  } else {
    watchRoot();
  }

  // Retour via le back/forward cache (pageshow)
  window.addEventListener(
    'pageshow',
    () => {
      mounted = false;
      watchRoot();
    },
    { passive: true }
  );
})();
